import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HugeiconsIconComponent } from '@hugeicons/angular';
import { CheckmarkCircle02Icon } from '@hugeicons/core-free-icons';

export interface ReminderAction {
    label: string;
    icon: any;
    btnClass: string;
    handler?: () => void;
    href?: string;
}

export interface Reminder {
    title: string;
    text: string;
    variant?: 'warning' | 'error' | 'info' | 'success';
    action?: ReminderAction;
    actions?: ReminderAction[];
}

@Component({
    selector: 'app-case-reminders',
    standalone: true,
    imports: [CommonModule, HugeiconsIconComponent],
    templateUrl: './case-reminders.component.html',
    styleUrl: './case-reminders.component.scss'
})
export class CaseRemindersComponent {
    @Input() reminders: Reminder[] = [];
    @Input() caseProgress: number = 0;
    @Input() moneyReceived: boolean = false;
    @Input() offerStatus: string | null = null;

    checkIcon = CheckmarkCircle02Icon;
}
